// src/components/dialog/DlgInstallationExport.tsx

import { Dialog, DialogTitle } from '@mui/material'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

export const DlgInstallationExport = ({ open, onClose }: KARMA_BasicDialog) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Daten exportieren</DialogTitle>
  </Dialog>
)
